(function () {
  var LANG = document.documentElement.lang;
  var AR = LANG === "ar", HE = LANG === "he";
  function t(ar, he, en) { return AR ? ar : (HE ? he : en); }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  }

  function toast(message) {
    var el = document.querySelector(".fk26-toast");
    if (!el) {
      el = document.createElement("div");
      el.className = "fk26-toast";
      el.innerHTML = '<span></span><a href="' + root() + 'cart"></a>';
      document.body.appendChild(el);
    }
    el.querySelector("span").textContent = message;
    el.querySelector("a").textContent = t("السلة", "לסל", "View cart");
  }

  function track(name, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, detail || {}));
  }

  function drawerSection() {
    var drawer = document.getElementById("Cart-Drawer");
    return drawer && drawer.dataset.section && !drawer.hasAttribute("data-status-silence") ? drawer.dataset.section : null;
  }

  function shippingLine(cart) {
    var drawer = document.getElementById("Cart-Drawer");
    var header = drawer && drawer.querySelector(".drawer-header");
    if (!header) return;
    var line = header.querySelector(".fk26-ship");
    if (!line) {
      line = document.createElement("p");
      line.className = "fk26-ship";
      header.appendChild(line);
    }
    var goal = 40000;
    var left = goal - (cart && cart.total_price ? cart.total_price : 0);
    if (!cart || !cart.item_count || left <= 0) {
      line.remove();
      return;
    }
    var amount = Math.ceil(left / 100);
    line.textContent = t("ضيفوا بـ " + amount + " ₪ والتوصيل علينا", "עוד " + amount + " ₪ והמשלוח עלינו", "Add " + amount + " ₪ and shipping is on us");
  }

  function openCart(button) {
    var drawer = document.getElementById("Cart-Drawer");
    if (drawer && typeof drawer.show === "function" && !drawer.hasAttribute("data-status-silence")) {
      drawer.show(button || null);
      return true;
    }
    return false;
  }

  /* put fresh drawer + bubble HTML (returned by cart/add.js) straight into the page */
  function paintSections(sections) {
    if (!sections) return;
    var P = new DOMParser();
    var sec = drawerSection();
    if (sec && sections[sec]) {
      var doc = P.parseFromString(sections[sec], "text/html");
      var fresh = doc.getElementById("Cart-Drawer-Details");
      var cur = document.getElementById("Cart-Drawer-Details");
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      if (cur) cur.querySelectorAll("img[data-srcset], img[data-src]").forEach(function (im) {
        if (im.dataset.sizes) im.sizes = im.dataset.sizes;
        if (im.dataset.srcset) im.srcset = im.dataset.srcset;
        if (im.dataset.src) im.src = im.dataset.src;
        im.classList.remove("image-lazy-loading", "loading-animation--breathing");
        im.style.opacity = "1";
      });
      var nd = doc.querySelector("cart-drawer");
      var d = document.getElementById("Cart-Drawer");
      if (nd && d) { var open = d.hasAttribute("open"); d.className = nd.className; if (open) d.setAttribute("open", ""); }
    }
    if (sections["cart-icon-bubble"]) {
      var b = P.parseFromString(sections["cart-icon-bubble"], "text/html").querySelector(".shopify-section");
      var tgt = document.getElementById("Cart-Icon-Bubble");
      if (b && tgt) tgt.innerHTML = b.innerHTML;
    }
  }

  function busy(button, on) {
    if (!button) return;
    button.disabled = on;
    button.classList.toggle("is-busy", on);
    button.setAttribute("aria-busy", on ? "true" : "false");
  }

  /* one request: add the pieces and get the drawer + bubble back in the same response */
  function add(ids, button) {
    var counts = {};
    ids.filter(Boolean).forEach(function (id) {
      var key = String(id);
      counts[key] = (counts[key] || 0) + 1;
    });
    var items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
    if (!items.length) return Promise.resolve(false);
    busy(button, true);
    var names = ["cart-icon-bubble"];
    var sec = drawerSection();
    if (sec) names.push(sec);
    return fetch(root() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-FK": "1" },
      body: JSON.stringify({ items: items, sections: names.join(","), sections_url: window.location.pathname })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body && body.description || "cart");
          return body;
        });
      })
      .then(function (response) {
        paintSections(response.sections);
        if (!openCart(button)) toast(t("أُضيفت إلى السلة", "נוסף לסל", "Added to your cart"));
        var exp = button && button.closest("[data-fk-exp]") ? button.closest("[data-fk-exp]").getAttribute("data-fk-exp") : "";
        track("fk26_add_to_cart", { experiment_id: exp, variant_id: document.documentElement.getAttribute("data-fk26-" + exp) || "" });
        /* shipping goal line: not on the critical path */
        fetch(root() + "cart.js").then(function (res) { return res.json(); }).then(shippingLine).catch(function () {});
        return true;
      })
      .catch(function (err) {
        toast(err && err.message && err.message !== "cart" ? err.message : t("تعذّر الإضافة", "לא ניתן להוסיף", "Could not add this piece"));
        return false;
      })
      .finally(function () { busy(button, false); });
  }

  /* product JSON cache, warmed when a card comes into view, so a tap adds at once */
  var productCache = {};
  function productJSON(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(root() + "products/" + handle + ".js").then(function (res) {
        if (!res.ok) throw new Error("product");
        return res.json();
      });
      productCache[handle].catch(function () { delete productCache[handle]; });
    }
    return productCache[handle];
  }
  var warm = "IntersectionObserver" in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      warm.unobserve(e.target);
      var h = e.target.getAttribute("data-fk-handle");
      if (h) productJSON(h).catch(function () {});
    });
  }, { rootMargin: "300px" }) : null;

  function bind(scope) {
    (scope || document).querySelectorAll("[data-fk-add]").forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = "1";
      btn.addEventListener("click", function () { add([btn.getAttribute("data-fk-add")], btn); });
    });

    (scope || document).querySelectorAll("[data-fk-mix]").forEach(function (box) {
      if (box.dataset.bound) return;
      box.dataset.bound = "1";
      function selected() {
        return Array.prototype.slice.call(box.querySelectorAll(".fk26-opt.is-on"));
      }
      function paint() {
        var picks = selected();
        var stage = box.querySelector("[data-fk-stage]");
        var total = 0;
        var img = picks[0] && picks[0].getAttribute("data-img");
        picks.forEach(function (p) { total += Number(p.getAttribute("data-price") || 0); });
        if (stage && img) stage.src = img;
        var sum = box.querySelector("[data-fk-sum]");
        if (sum) sum.textContent = (total / 100).toFixed(0);
        var many = box.querySelector("[data-fk-add-many]");
        if (many) many.setAttribute("data-ids", picks.map(function (p) { return p.getAttribute("data-variant"); }).join(","));
      }
      box.querySelectorAll(".fk26-opt").forEach(function (opt) {
        opt.addEventListener("click", function () {
          var role = opt.getAttribute("data-role");
          box.querySelectorAll('.fk26-opt[data-role="' + role + '"]').forEach(function (n) { n.classList.remove("is-on"); });
          opt.classList.add("is-on");
          paint();
        });
      });
      var surprise = box.querySelector("[data-fk-surprise]");
      if (surprise) {
        surprise.addEventListener("click", function () {
          var roles = {};
          box.querySelectorAll(".fk26-opt").forEach(function (opt) {
            var role = opt.getAttribute("data-role");
            roles[role] = roles[role] || [];
            roles[role].push(opt);
          });
          Object.keys(roles).forEach(function (role) {
            roles[role].forEach(function (n) { n.classList.remove("is-on"); });
            var pick = roles[role][Math.floor(Math.random() * roles[role].length)];
            if (pick) pick.classList.add("is-on");
          });
          paint();
        });
      }
      var many = box.querySelector("[data-fk-add-many]");
      if (many) {
        many.addEventListener("click", function () {
          add((many.getAttribute("data-ids") || "").split(","), many);
        });
      }
      paint();
    });

    /* "Add to cart" on every theme product card (collections, search, related) */
    (scope || document).querySelectorAll(".product-card-wrapper").forEach(function (card) {
      if (card.querySelector(".fk26-grab")) return;
      var opener = card.querySelector("[data-product-handle]");
      var handle = opener && opener.getAttribute("data-product-handle");
      if (!handle) {
        var productLink = card.querySelector('a[href*="/products/"]');
        var match = productLink && (productLink.getAttribute("href") || "").match(/\/products\/([^/?#]+)/);
        handle = match && decodeURIComponent(match[1]);
      }
      if (!handle) return;
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "fk26-grab";
      btn.setAttribute("data-fk-handle", handle);
      btn.textContent = t("أضيفوا للسلة", "הוסיפו לסל", "Add to cart");
      var slot = card.querySelector(".card-price") || card.querySelector(".card-content") || card;
      slot.appendChild(btn);
      if (warm) warm.observe(btn);
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        busy(btn, true);
        productJSON(handle)
          .then(function (product) {
            var variant = (product.variants || []).filter(function (v) { return v.available; })[0];
            if (!variant) {
              busy(btn, false);
              btn.disabled = true;
              btn.textContent = t("نفذت", "אזל", "Sold out");
              return;
            }
            return add([variant.id], btn);
          })
          .catch(function () {
            busy(btn, false);
            toast(t("افتحوا القطعة لاختيار التفاصيل", "פתחו את המוצר לבחירת פרטים", "Open the piece to choose details"));
          });
      });
    });

    (scope || document).querySelectorAll("[data-fk-tray]").forEach(function (box) {
      if (box.dataset.bound) return;
      box.dataset.bound = "1";
      var picks = [];
      var slots = box.querySelectorAll("[data-fk-slot]");
      var caption = box.querySelector("[data-fk-tray-caption]");
      var price = box.querySelector("[data-fk-tray-price]");
      var addBtn = box.querySelector("[data-fk-tray-add]");
      function say(n) {
        if (AR) {
          if (n === 0) return "العلبة فاضية — اختاروا أول فنجان";
          if (n === 1) return "فنجان واحد بالعلبة";
          if (n === 2) return "فنجانين بالعلبة";
          if (n === 3) return "ثلاثة فناجين — باقي محل";
          return "العلبة كاملة، أربع فناجين";
        }
        if (HE) {
          if (n === 0) return "הקופסה ריקה — בחרו ספל";
          if (n === 4) return "הקופסה מלאה, ארבעה ספלים";
          return n + " מתוך 4";
        }
        if (n === 0) return "Empty box — choose the first cup";
        if (n === 4) return "The box is full";
        return n + " of 4 cups in the box";
      }
      function render() {
        slots.forEach(function (slot, index) {
          var img = slot.querySelector("img");
          var pick = picks[index];
          if (pick) {
            slot.classList.add("is-filled");
            img.alt = pick.label;
            img.src = pick.img;
          } else {
            slot.classList.remove("is-filled");
            img.removeAttribute("src");
            img.alt = "";
          }
        });
        box.querySelectorAll("[data-fk-cup]").forEach(function (cup) {
          var n = picks.filter(function (pick) { return pick.variant === cup.getAttribute("data-variant"); }).length;
          cup.classList.toggle("is-picked", n > 0);
        });
        if (caption) caption.textContent = say(picks.length);
        if (price) {
          var cents = picks.reduce(function (sum, pick) { return sum + pick.cents; }, 0);
          price.textContent = picks.length ? Math.round(cents / 100) + " ₪" : "";
        }
        if (addBtn) addBtn.disabled = picks.length !== slots.length;
      }
      box.querySelectorAll("[data-fk-cup]").forEach(function (cup) {
        cup.addEventListener("click", function () {
          if (cup.disabled || picks.length >= slots.length) return;
          var variant = cup.getAttribute("data-variant");
          var stock = Number(cup.getAttribute("data-stock") || "1");
          var used = picks.filter(function (pick) { return pick.variant === variant; }).length;
          if (used >= stock) {
            toast(t("خلص هالفنجان من المخزون", "הספל הזה אזל מהמלאי", "No more of this cup in stock"));
            return;
          }
          picks.push({
            variant: variant,
            img: cup.getAttribute("data-img"),
            label: cup.getAttribute("data-label") || "",
            cents: Number(cup.getAttribute("data-cents") || "0")
          });
          render();
        });
      });
      slots.forEach(function (slot, index) {
        slot.addEventListener("click", function () {
          if (!picks[index]) return;
          picks.splice(index, 1);
          render();
        });
      });
      if (addBtn) {
        addBtn.addEventListener("click", function () {
          if (picks.length !== slots.length) return;
          add(picks.map(function (pick) { return pick.variant; }), addBtn).then(function (ok) {
            if (ok) picks = [];
            render();
          });
        });
      }
      var clearBtn = box.querySelector("[data-fk-tray-clear]");
      if (clearBtn) {
        clearBtn.addEventListener("click", function () {
          picks = [];
          render();
        });
      }
      render();
    });

    var buy = document.querySelector(".product-form-buttons");
    if (buy && !document.querySelector(".fk26-trust")) {
      var note = document.createElement("p");
      note.className = "fk26-trust";
      note.textContent = t("مصنوع يدوياً في مراكش · تغليف فاخر · يصل خلال 24–48 ساعة",
        "עבודת יד ממרקש · אריזה מהודרת · מגיע תוך 24–48 שעות",
        "Handmade in Marrakesh · Packed with care · Arrives in 24–48 hours");
      buy.insertAdjacentElement("afterend", note);
    }
  }

  function start() {
    bind();
    fetch(root() + "cart.js").then(function (res) { return res.json(); }).then(shippingLine).catch(function () {});
    /* collection pages swap their product grid without a reload (pagination, filters, sort):
       watch for new cards and give them their buttons again */
    var pending = 0;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].addedNodes.length) {
          cancelAnimationFrame(pending);
          pending = requestAnimationFrame(function () { bind(); });
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
  document.addEventListener("shopify:section:load", function (event) { bind(event.target); });
  /* back / forward from the cache */
  window.addEventListener("pageshow", function (e) { if (e.persisted) bind(); });
})();
